import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialFormStackModule } from '@zerops/zerops/core/material-form-stack';
import { ZefFormsModule } from '@zerops/zef/forms';
import { UserInfoFieldsModule } from '@zerops/zui/user-info-fields';
import { AccountFormComponent } from './account-form.component';

@NgModule({
  declarations: [ AccountFormComponent ],
  imports: [
    CommonModule,
    ZefFormsModule,
    UserInfoFieldsModule,
    MaterialFormStackModule
  ],
  exports: [ AccountFormComponent ]
})
export class AccountFormModule {

}
